import { render, staticRenderFns } from "./InvestmentCertificates.vue?vue&type=template&id=d44e30dc&scoped=true"
import script from "./InvestmentCertificates.vue?vue&type=script&lang=js"
export * from "./InvestmentCertificates.vue?vue&type=script&lang=js"
import style0 from "./InvestmentCertificates.vue?vue&type=style&index=0&id=d44e30dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44e30dc",
  null
  
)

export default component.exports